import produce from "immer"
import { ACTIVE, ASC } from "const"
import { MtModule } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const moduleIds = {
    sil: 3,
    markov: 7,
    qid: 9,
    lifecycle: 12,
    cc: 14,
    study: 15,
    riskSpace: 16,
}

export const initModule: MtModule = {
    id: null,
    name: "",
    shortName: "",
    description: "",
    logoId: null,
    copyright: "",
    status: ACTIVE,
}

const initModuleState: types.ModuleState = {
    moduleList: {},
    moduleIds: [],
    moduleView: initModule,
    moduleEdit: initModule,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        status: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const moduleReducer = produce((
    draft: types.ModuleState = initModuleState,
    action: ActionTypes = null,
): types.ModuleState => {
    switch (action.type) {
        case types.MODULE_LIST:
            draft.moduleList = action.moduleList
            return draft

        case types.MODULE_IDS:
            draft.moduleIds = action.moduleIds
            return draft

        case types.MODULE_VIEW:
            draft.moduleView = action.module
            return draft

        case types.MODULE_EDIT:
            draft.moduleEdit = action.module
            return draft

        case types.MODULE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MODULE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MODULE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MODULE_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.MODULE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default moduleReducer
